'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

interface Props {
  employees: any[];
}

export default function HeadcountStatsRow({ employees }: Props) {
  const total = employees.length;
  const active = employees.filter((e) => e.employee_status === 'Active').length;
  const onLeave = employees.filter((e) => e.employee_status === 'On Leave').length;
  const probation = employees.filter((e) => e.employee_status === 'Probation').length;
  const onboarding = employees.filter((e) => e.employee_status === 'Onboarding').length;

  const stats = [
    { id: 'hc-total', label: 'Total Headcount', value: total, icon: 'UserGroupIcon', color: 'var(--primary)', bg: 'rgba(0,212,255,0.1)', href: '/hr-center' },
    { id: 'hc-active', label: 'Active', value: active, icon: 'CheckCircleIcon', color: 'var(--color-green)', bg: 'rgba(16,185,129,0.1)', href: '/hr-center' },
    { id: 'hc-leave', label: 'On Leave', value: onLeave, icon: 'ClockIcon', color: 'var(--color-blue)', bg: 'rgba(59,130,246,0.1)', href: '/hr-center' },
    { id: 'hc-probation', label: 'Probation', value: probation, icon: 'AcademicCapIcon', color: 'var(--color-amber)', bg: 'rgba(245,158,11,0.1)', href: '/hr-center' },
    { id: 'hc-onboarding', label: 'Onboarding', value: onboarding, icon: 'UserPlusIcon', color: 'var(--color-purple)', bg: 'rgba(139,92,246,0.1)', href: '/hr-center' },
  ];

  return (
    <div className="card-elevated rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.1)' }}>
            <Icon name="UserGroupIcon" size={15} className="text-primary" />
          </div>
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest">Headcount Overview</p>
        </div>
        <Link href="/hr-center" className="flex items-center gap-1 text-xs text-primary hover:underline">
          HR Center <Icon name="ArrowRightIcon" size={11} />
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {stats.map((stat) => (
          <Link key={stat.id} href={stat.href}
            className="rounded-xl p-3 flex items-center gap-2.5 hover:scale-[1.02] transition-transform duration-150 cursor-pointer"
            style={{ background: 'var(--muted)', border: '1px solid var(--border)' }}>
            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: stat.bg }}>
              <Icon name={stat.icon as any} size={16} style={{ color: stat.color } as React.CSSProperties} />
            </div>
            <div>
              <p className="text-lg font-bold tabular-nums text-card-foreground leading-tight">{stat.value}</p>
              <p className="text-xs text-muted-foreground leading-tight">{stat.label}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
